import React from 'react';

// Набор иконок админпанели.
// Все — inline SVG, 24×24, stroke-based, currentColor.
// Использование:
//   import { IconStudents, IconJournal } from '../../components/Icons';
//   <IconStudents width={20} height={20} />
//
// Цвет управляется через CSS color родителя — иконка использует currentColor.

const baseProps = {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 2,
    strokeLinecap: 'round',
    strokeLinejoin: 'round',
};

// --- Навигация / меню ---

export function IconDashboard(props) {
    return (
        <svg {...baseProps} {...props}>
            <rect x="3" y="3" width="8" height="9" rx="2"/>
            <rect x="13" y="3" width="8" height="5" rx="2"/>
            <rect x="3" y="14" width="8" height="7" rx="2"/>
            <rect x="13" y="10" width="8" height="11" rx="2"/>
        </svg>
    );
}

export function IconStudents(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="8.5" cy="7" r="4"/>
            <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
    );
}

export function IconJournal(props) {
    return (
        <svg {...baseProps} {...props}>
            <rect x="3" y="4" width="18" height="17" rx="3"/>
            <path d="M8 2v4M16 2v4M3 10h18"/>
            <path d="M8 15l2 2 4-4"/>
        </svg>
    );
}

export function IconEvents(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M12 2l3 7h7l-5.5 4.5 2 7.5L12 17l-6.5 4 2-7.5L2 9h7z"/>
        </svg>
    );
}

export function IconPays(props) {
    return (
        <svg {...baseProps} {...props}>
            <rect x="2" y="6" width="20" height="12" rx="2"/>
            <circle cx="12" cy="12" r="2.5"/>
            <path d="M6 12h0M18 12h0"/>
        </svg>
    );
}

export function IconSettings(props) {
    return (
        <svg {...baseProps} {...props}>
            <circle cx="12" cy="12" r="3"/>
            <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
        </svg>
    );
}

export function IconAccounts(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
        </svg>
    );
}

export function IconShieldCheck(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M12 2L4 7v6c0 5 3.5 9 8 10 4.5-1 8-5 8-10V7l-8-5z"/>
            <path d="M9 12l2 2 4-4"/>
        </svg>
    );
}

export function IconChart(props) {
    return (
        <svg {...baseProps} {...props}>
            <rect x="3" y="13" width="4" height="8" rx="1"/>
            <rect x="10" y="8" width="4" height="13" rx="1"/>
            <rect x="17" y="3" width="4" height="18" rx="1"/>
        </svg>
    );
}

export function IconBook(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
            <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
        </svg>
    );
}

export function IconUser(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
            <circle cx="12" cy="7" r="4"/>
        </svg>
    );
}

export function IconLogout(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
            <polyline points="16 17 21 12 16 7"/>
            <line x1="21" y1="12" x2="9" y2="12"/>
        </svg>
    );
}

// --- Действия ---

export function IconSearch(props) {
    return (
        <svg {...baseProps} {...props}>
            <circle cx="11" cy="11" r="8"/>
            <line x1="21" y1="21" x2="16.65" y2="16.65"/>
        </svg>
    );
}

export function IconPlus(props) {
    return (
        <svg {...baseProps} {...props}>
            <line x1="12" y1="5" x2="12" y2="19"/>
            <line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
    );
}

export function IconEdit(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
        </svg>
    );
}

export function IconTrash(props) {
    return (
        <svg {...baseProps} {...props}>
            <polyline points="3 6 5 6 21 6"/>
            <path d="M19 6l-2 14a2 2 0 0 1-2 2H9a2 2 0 0 1-2-2L5 6"/>
            <path d="M10 11v6M14 11v6"/>
            <path d="M9 6V4a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2"/>
        </svg>
    );
}

export function IconCheck(props) {
    return (
        <svg {...baseProps} {...props}>
            <polyline points="20 6 9 17 4 12"/>
        </svg>
    );
}

export function IconClose(props) {
    return (
        <svg {...baseProps} {...props}>
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    );
}

export function IconArrowRight(props) {
    return (
        <svg {...baseProps} {...props}>
            <line x1="5" y1="12" x2="19" y2="12"/>
            <polyline points="12 5 19 12 12 19"/>
        </svg>
    );
}

export function IconArrowLeft(props) {
    return (
        <svg {...baseProps} {...props}>
            <line x1="19" y1="12" x2="5" y2="12"/>
            <polyline points="12 19 5 12 12 5"/>
        </svg>
    );
}

export function IconChevronDown(props) {
    return (
        <svg {...baseProps} {...props}>
            <polyline points="6 9 12 15 18 9"/>
        </svg>
    );
}

export function IconChevronUp(props) {
    return (
        <svg {...baseProps} {...props}>
            <polyline points="18 15 12 9 6 15"/>
        </svg>
    );
}

export function IconRefresh(props) {
    return (
        <svg {...baseProps} {...props}>
            <polyline points="23 4 23 10 17 10"/>
            <polyline points="1 20 1 14 7 14"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10"/>
            <path d="M20.49 15a9 9 0 0 1-14.85 3.36L1 14"/>
        </svg>
    );
}

export function IconMenu(props) {
    return (
        <svg {...baseProps} {...props}>
            <line x1="3" y1="12" x2="21" y2="12"/>
            <line x1="3" y1="6" x2="21" y2="6"/>
            <line x1="3" y1="18" x2="21" y2="18"/>
        </svg>
    );
}

// --- Игровые элементы (для геймификации) ---

export function IconDiamond(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M6 3h12l4 6-10 13L2 9z"/>
            <path d="M11 3 8 9l4 13 4-13-3-6"/>
            <path d="M2 9h20"/>
        </svg>
    );
}

export function IconStar(props) {
    return (
        <svg {...baseProps} {...props}>
            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/>
        </svg>
    );
}

export function IconTrophy(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/>
            <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/>
            <path d="M4 22h16"/>
            <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"/>
            <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"/>
            <path d="M18 2H6v7a6 6 0 0 0 12 0V2z"/>
        </svg>
    );
}

// --- Информационные ---

export function IconInfo(props) {
    return (
        <svg {...baseProps} {...props}>
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="16" x2="12" y2="12"/>
            <line x1="12" y1="8" x2="12.01" y2="8"/>
        </svg>
    );
}

export function IconAlert(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/>
            <line x1="12" y1="9" x2="12" y2="13"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
    );
}

export function IconClock(props) {
    return (
        <svg {...baseProps} {...props}>
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
        </svg>
    );
}

export function IconCalendar(props) {
    return (
        <svg {...baseProps} {...props}>
            <rect x="3" y="4" width="18" height="18" rx="2"/>
            <line x1="16" y1="2" x2="16" y2="6"/>
            <line x1="8" y1="2" x2="8" y2="6"/>
            <line x1="3" y1="10" x2="21" y2="10"/>
        </svg>
    );
}

export function IconMail(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
            <polyline points="22 6 12 13 2 6"/>
        </svg>
    );
}

export function IconPhone(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
        </svg>
    );
}

export function IconExternal(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/>
            <polyline points="15 3 21 3 21 9"/>
            <line x1="10" y1="14" x2="21" y2="3"/>
        </svg>
    );
}

export function IconEye(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
            <circle cx="12" cy="12" r="3"/>
        </svg>
    );
}

export function IconRobot(props) {
    return (
        <svg {...baseProps} {...props}>
            <rect x="5" y="7" width="14" height="12" rx="2"/>
            <path d="M9 7V4M15 7V4M9 4h6"/>
            <circle cx="9" cy="13" r="1.2"/>
            <circle cx="15" cy="13" r="1.2"/>
            <line x1="3" y1="13" x2="5" y2="13"/>
            <line x1="19" y1="13" x2="21" y2="13"/>
        </svg>
    );
}

export function IconGamepad(props) {
    return (
        <svg {...baseProps} {...props}>
            <line x1="6" y1="11" x2="10" y2="11"/>
            <line x1="8" y1="9" x2="8" y2="13"/>
            <line x1="15" y1="12" x2="15.01" y2="12"/>
            <line x1="18" y1="10" x2="18.01" y2="10"/>
            <path d="M17.32 5H6.68a4 4 0 0 0-3.978 3.59L2.03 15a3 3 0 0 0 2.97 3.39 3 3 0 0 0 2.46-1.29l.93-1.27c.385-.526.99-.83 1.61-.83h4a2 2 0 0 1 1.61.83l.93 1.27a3 3 0 0 0 2.46 1.29 3 3 0 0 0 2.97-3.39l-.67-6.41A4 4 0 0 0 17.32 5z"/>
        </svg>
    );
}

export function IconFolder(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z"/>
        </svg>
    );
}

export function IconMessage(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/>
        </svg>
    );
}

export function IconHelp(props) {
    return (
        <svg {...baseProps} {...props}>
            <circle cx="12" cy="12" r="10"/>
            <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"/>
            <line x1="12" y1="17" x2="12.01" y2="17"/>
        </svg>
    );
}

export function IconFilter(props) {
    return (
        <svg {...baseProps} {...props}>
            <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3"/>
        </svg>
    );
}

export function IconDownload(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
    );
}

export function IconUpload(props) {
    return (
        <svg {...baseProps} {...props}>
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="17 8 12 3 7 8"/>
            <line x1="12" y1="3" x2="12" y2="15"/>
        </svg>
    );
}

export function IconCoin(props) {
    return (
        <svg {...baseProps} {...props}>
            <circle cx="12" cy="12" r="9"/>
            <path d="M12 6v12M9 9h4.5a1.5 1.5 0 0 1 0 3H9a1.5 1.5 0 0 0 0 3h6"/>
        </svg>
    );
}

export function IconTrendUp(props) {
    return (
        <svg {...baseProps} {...props}>
            <polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/>
            <polyline points="17 6 23 6 23 12"/>
        </svg>
    );
}

export function IconImage(props) {
    return (
        <svg {...baseProps} {...props}>
            <rect x="3" y="3" width="18" height="18" rx="2"/>
            <circle cx="8.5" cy="8.5" r="1.5"/>
            <polyline points="21 15 16 10 5 21"/>
        </svg>
    );
}
